import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon57: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M7 0a7 7 0 0 1 6.295 10.064l6.035 6.035a2.284 2.284 0 1 1-3.23 3.231l-6.037-6.034A7 7 0 1 1 7 0Zm3.957 12.775 5.85 5.849a1.285 1.285 0 0 0 1.816-1.817l-5.849-5.849a7.054 7.054 0 0 1-1.817 1.817ZM7 1a6 6 0 1 0 0 12A6 6 0 0 0 7 1Z"
      />
    </Svg>
  )
}
